import React from 'react';
import { useLocation } from 'react-router';
import { withI18N } from 'shared-components/hoc-components';
import compose from 'utils/helper-functions/compose';
import TransactionTabsHeader from '@pano-project/components/TransactionTabsHeader/TransactionTabsHeader';
import { resolveBootPage } from 'utils/helper-functions/get-landing-page';
import { useBootHeaderSettings } from './useBootHeaderSettings';
import { useHeaderElements } from './useHeaderElements';

interface BootHeaderProps {
  lang?: (key: string) => string;
}

const BootHeader = ({ lang }: BootHeaderProps) => {
  const { layout, transactionType, sessionType, withPending, showAnyHeaderButton, bootIntents } =
    useBootHeaderSettings();
  const { pathname } = useLocation();
  const { showPaymentType, balance } = useHeaderElements({
    currentPage: resolveBootPage(pathname),
  });

  const resolveLabel = (key: string) => lang?.(key) ?? '';
  const isAmountFirst = layout === 'amount-first';

  const header = (
    <header
      className={`main-header ${sessionType === 'vt' ? 'header-virtual_terminal' : ''} ${
        showAnyHeaderButton ? '_show-hide-and-back-buttons' : ''
      }`.trim()}
    >
      <TransactionTabsHeader
        transactionType={transactionType}
        startupIntents={bootIntents ?? undefined}
        lang={resolveLabel}
        withPending={isAmountFirst && withPending}
        className="main-header__tabs"
        balanceTabClassName={transactionType}
        showPaymentType={showPaymentType}
        balance={balance}
      />
    </header>
  );

  if (isAmountFirst) {
    return (
      <div className="amount-first-page__content-wrapper">
        <div className="amount-first-page">
          <div className="amount-first-page__main-fold">{header}</div>
        </div>
      </div>
    );
  }

  return header;
};

export default compose(withI18N)(BootHeader);
